import {Component, Input, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../ext-profiles.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {IUser} from 'app/interfaces/IUser'
import {TranslocoService} from "@ngneat/transloco";

@UntilDestroy()
@Component({
  selector: 'app-generic-uniq',
  templateUrl: './generic-uniq.component.html',
  styleUrls: ['./generic-uniq.component.scss'],
})
export class GenericUniqComponent implements OnInit {

  cUser: IUser;
  @Input() keyname: string;
  @Input() curLang: string;
  @Input() displayDebug: false;

  constructor(
    private userService: UserService,
    public extProfilesService: ExtProfilesService,
    public translocoService: TranslocoService,
  ) {


  }

  ngOnInit(): void {

    this.userService.user$.pipe(untilDestroyed(this)).subscribe((aUser) => {
      this.cUser = aUser;
    })
  }

  setExt(value: string) {
    this.extProfilesService.updateExtProfiles(this.keyname, value);
  }


}
